import React, {Component} from 'react';
import {Translation} from 'react-i18next';

import MediumForm from '../containers/MediumFormContainer';
import DocumentHead from '../../../elements/components/DocumentHead';
import Logger from '../../../../../lib/Logger';

class MediumEditScreen extends Component {

  scrollToTop = () => {
    Logger.log('debug', `MediumEditScreen.scrollToTop()`);
    if (typeof window !== 'undefined') {
      setTimeout(() => window.scrollTo(0, 0), 100);
    }
  }

  render() {
    return (
      <Translation>{(t) => 
        <div>
          <DocumentHead title={t('media_route_edit')} />
          <MediumForm id={this.props.match.params.id} />
        </div>
      }</Translation>
    )
  }

  /* LIFECYCLE EVENTS */

  componentDidMount() {
    this.scrollToTop();
  }
}

export default MediumEditScreen;

Logger.log('silly', `MediumEditScreen loaded.`);
